if (!customElements.get('product-features')) {
  customElements.define(
    'product-features',
    class ProductFeatures extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.addEventListener('change', (e) => {
          const radio = e.target.closest('[data-action]');
          if (!radio) return;
          e.stopPropagation();

          const {
            action,
            tabTarget,
            tempTarget
          } = radio.dataset;

          switch (action) {
            case 'tab':
              [...this.querySelectorAll('[data-tab-content]')].forEach(panel => {
                const isVisible = panel.dataset.tabContent === tabTarget;
                panel.style.display = isVisible ? '' : 'none';
              });
              break;

            case 'temp':
              [...this.querySelectorAll('[data-temp-content]')].forEach(panel => {
                const isVisible = panel.dataset.tempContent === tempTarget;
                panel.style.display = isVisible ? '' : 'none';
              });
              break;
          }
        });
      }
    }
  );
}
